import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { purchaseAPI } from '../api';
import toast from 'react-hot-toast';

export default function MyTicketsPage() {
  const [email, setEmail] = useState('');
  const [tickets, setTickets] = useState(null);
  const [loading, setLoading] = useState(false);

  const search = async () => {
    if (!email) { toast.error('Enter your email'); return; }
    setLoading(true);
    try {
      const res = await purchaseAPI.byEmail(email);
      setTickets(res.data);
      if (res.data.length === 0) toast('No tickets found for this email', { icon: 'ℹ️' });
    } catch { toast.error('Search failed. Try again.'); }
    finally { setLoading(false); }
  };

  return (
    <div style={{ minHeight: '100vh', background: '#f8f9fa' }}>
      <div style={{ background: '#1A2744', padding: '16px 24px', display: 'flex', alignItems: 'center', gap: 16 }}>
        <Link to="/" style={{ color: 'rgba(255,255,255,0.6)', fontSize: 14 }}>← Events</Link>
        <span style={{ color: '#fff', fontWeight: 700, fontFamily: "'Playfair Display', serif" }}>My Tickets</span>
      </div>

      <div style={{ maxWidth: 600, margin: '0 auto', padding: '40px 24px' }}>
        <div style={{ background: '#fff', borderRadius: 12, padding: 24, marginBottom: 24 }}>
          <h2 style={{ fontFamily: "'Playfair Display', serif", color: '#1A2744', margin: '0 0 16px' }}>Find Your Tickets</h2>
          <div style={{ display: 'flex', gap: 10 }}>
            <input type="email" placeholder="Enter your email address" value={email} onChange={e => setEmail(e.target.value)}
              onKeyDown={e => e.key === 'Enter' && search()}
              style={{ flex: 1, padding: '10px 14px', border: '1px solid #D1D5DB', borderRadius: 8, fontSize: 14 }} />
            <button onClick={search} disabled={loading}
              style={{ background: '#E8521A', color: '#fff', padding: '10px 20px', borderRadius: 8, border: 'none', fontWeight: 700, cursor: 'pointer' }}>
              {loading ? '...' : 'Search'}
            </button>
          </div>
        </div>

        {tickets && tickets.map(t => (
          <div key={t.id} style={{ background: '#fff', borderRadius: 12, padding: 20, marginBottom: 12, display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 12 }}>
            <div>
              <div style={{ fontWeight: 700, color: '#1A2744', fontFamily: "'Playfair Display', serif" }}>{t.event_name}</div>
              <div style={{ fontSize: 13, color: '#6B7280' }}>📅 {new Date(t.date).toLocaleDateString('en-KE', { dateStyle: 'medium' })} · {t.ticket_type_name} × {t.quantity}</div>
              <div style={{ fontSize: 12, color: '#E8521A', fontWeight: 700, marginTop: 4 }}>{t.ticket_code}</div>
            </div>
            <Link to={`/ticket/${t.ticket_code}`}
              style={{ background: '#1A2744', color: '#fff', padding: '8px 16px', borderRadius: 8, fontSize: 13, fontWeight: 600 }}>
              View Ticket
            </Link>
          </div>
        ))}
      </div>
    </div>
  );
}
